import { computed, ref } from "vue";

const enabled = ref(false);

export const useDevMode = () => {
  const clickCounts = ref(0);
  const currentTimeout = ref<number | null>(null);

  const handler = () => {
    clickCounts.value++;
    if (clickCounts.value % 3 === 0) {
      enabled.value = !enabled.value;
      console.log("Toggled devMode", enabled.value);
    }

    if (currentTimeout.value) {
      window.clearTimeout(currentTimeout.value);
    }
    currentTimeout.value = window.setTimeout(() => {
      clickCounts.value = 0;
    }, 500);
  };

  return { enabled: computed(() => enabled.value), handler };
};
